// EXTERNAL REACT LIBRARIES IMPORTS
import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";

//HOOKS
import useApi from "../../hooks/useApi";
import { useAuth } from "../../hooks/useAuth";

// UI
import Menu from "../../components/UI/Menu";
import ContentBox from "../../components/UI/ContentBox";
import Footer from "../../components/UI/Footer";
import NewsItemCourse from "../../components/UI/NewsItemCourse";
import Banner from "../../components/UI/Banner";
import { icons, images } from "../../constants";
import Visibility from "../../components/UI/Visibility";
import Modal from "../../components/UI/Modal"
import ReadMoreButton from "../../components/UI/ReadMoreButton"
import FullScreenLoading from "../../components/UI/FullScreenLoading";

import { format, getYear } from "date-fns";
import ptBR from "date-fns/esm/locale/pt-BR/";

import {
  Container,
  ContainerOptions,
  ListContent,
  MeetList,
  Meetings,
  MeetText,
  Meet,
  Item,
  Certificate,
  Message,
  Voltar,
  ImgAtencao,
  Alert,
} from "./styles";

const Courses = ({action}) => {
  const [coursesList, setCoursesList] = useState([]);
  const [coursesListSubscription, setCoursesListSubscription] = useState([]);
  const [certificateList, setCertificateList] = useState([]);
  const [pageModeControl, setPageModeControl] = useState(null);
  const [controlList, setControlList] = useState(
    {
      type:{
        name:null,
        list:[],
      },
      segment:{
        name:null,
        list:[],
      },
    }
  );

  const [ModalOpenAlertUnsubscribe, setModalOpenAlertUnsubscribe] = useState(false);
  const [unsubscriptionStatusMessage, setModalOpenUnsubscriptionStatusMessage] = useState("");

  const handleModalAlertUnsubscribe = () => {
    setModalOpenAlertUnsubscribe((oldModalOpenAlertUnsubscribe) => !oldModalOpenAlertUnsubscribe);
  };

  const handleAlertUnsubscribeOk = () => {
    window.location.reload();
  };

  //CONSTANTES
  const { user } = useAuth();
  const navigate = useNavigate();

  // FUNÇÕES
  const [unsubscribe, UnsubscribeInfo] = useApi({
    debounceDelay: 0,
    url: "canalPedagogico/course/subscription",
    method: "delete",
    onCompleted: (response) => {
      if (!response.error) {
        setModalOpenUnsubscriptionStatusMessage("Inscrição cancelada com sucesso!");
        handleModalAlertUnsubscribe();
        // console.log("deletou", response);
      }
    },
  });

  const [getCourses, getCoursesInfo] = useApi({
    debounceDelay: 1000,
    url: "canalPedagogico/course/byTerm/v2",
    method: "get",
    onCompleted: (response) => {
      if (!response.error) {
        console.log(response.data);
        if(action==='subscription'){
          let list = [];
          response.data.forEach((courseType)=>{
            courseType.segments.forEach((segment)=>{
                segment.courses.forEach((course)=>{
                  list.push(course);
                });
              });
          });
          setCoursesListSubscription(
            list.sort((a, b) => {
              let comparaData = parseInt(b.subscriptionBegin)-parseInt(a.subscriptionBegin);
              if(comparaData!==0){
                return comparaData;
              }
              else{
                return a.title.trim().localeCompare(b.title.trim());
              }
            })
          );
        }
        else{
          setCoursesList(response.data);
        }
      }
    },
  });

  const [getCertificate, getCertificateInfo] = useApi({
    debounceDelay: 1000,
    url: "canalPedagogico/course/certificate/byUser",
    method: "get",
    onCompleted: (response) => {
      if (!response.error) {
        console.log(response.data);
        setCertificateList(response.data);
      }
    },
    onError: (error) =>{
      console.log(error);
    }
  });

  const getEditorId = (type) => {
    let teste = user?.profiles[0]?.editor?.find(
      (item) => item.category === "Formações"
    );
    // setIsEditor(teste?.id ? true : false);
    return teste?.id ? teste.id : false;
  };

  const editorId = getEditorId();

  const handleUnsubscribe = (id) => {
    unsubscribe({
      data: {
        id
      },
    });
  };

  const renderCourse = (course)=>{
    return(<NewsItemCourse
                        id={course.id}
                        title={
                          <Link to={`/formacoes/${course.id}`}>
                            {course.title}
                          </Link>
                        }
                        titleText={course.title}
                        text={
                          <>
                            {course.meetingsDate.length>0 && <Meetings>
                              <MeetText>Dias de encontro:</MeetText>
                              <MeetList>
                                {course.meetingsDate.map((meet,index)=><Meet key={index}>
                                  {format(new Date(meet.eventdate), "dd/MM", {
                                                locale: ptBR,
                                              })}
                                  {format(new Date(meet.event_begin), " - HH:mm", {
                                                locale: ptBR,
                                              })}
                                  {format(new Date(meet.eventdate), " (cccccc)", {
                                                locale: ptBR,
                                              })}
                                </Meet>)}
                              </MeetList>
                            </Meetings>}
                            {course.hasSubscription && <span>
                                Periodo de inscrição: 
                                {format(parseInt(course.subscriptionBegin), " dd/MM/yyyy ", {locale: ptBR,})}
                                -
                                {format(parseInt(course.subscriptionEnd), " dd/MM/yyyy", {locale: ptBR,})}
                            </span>}
                            {course.hasSubscription && <span>Vagas: {`${(course.subscriptionsLimit-course.totalSubscriptions)<0?0:course.subscriptionsLimit-course.totalSubscriptions}/${course.subscriptionsLimit} atualizado em: ${course.dateSearch}`}</span>}
                            {editorId && course.visibilities?.length>0 && <span>
                              <Visibility visibility={course.visibilities} />
                            </span>}
                          </>
                        }
                        mainCategory="Formações"
                        editorId={editorId}
                        url={`/formacoes/editar/${course.id}`}
                        subscriptionByChannel={course.hasSubscription}
                        subscriptionEnabled = {course.subscriptionEnabled}
                        idUserSubscription = {course.idUserSubscription}
                        subscriptionStatusMessage = {course.subscriptionStatusMessage}
                        subscriptionBegin = {course.subscriptionBegin}
                        subscriptionEnd = {course.subscriptionEnd}
                        subscriptionCancel = {handleUnsubscribe}
                      />)
  }

  const loadCourses = ()=>{
    console.log("pageModeControl", pageModeControl);
    if(pageModeControl===1 && user){
      getCourses({params:{onlySubscriptions:1}});
    }
    if(pageModeControl===4){
      getCourses();
    }
    if(pageModeControl===3){
      getCourses({params:{year:getYear(new Date())-1}});
    }
    if(user){
      getCertificate({params:{idUser:user.dados.idUser}})
    }
  }

  const back = () => {
    if(controlList.segment.list.length>0){
      if(controlList.type.list.length===1){
        setControlList({
                    type:{
                      name:null,
                      list:[]
                    },
                    segment:{
                      name:null,
                      list:[]
                    }})
      }
      else{
        setControlList({
                    type:controlList.type,
                    segment:{
                      name:null,
                      list:[]
                    }})
      }
    }
    else{
      if(controlList.type.list.length>0){
        setControlList({
                    type:{
                      name:null,
                      list:[]
                    },
                    segment:{
                      name:null,
                      list:[]
                    }})
      }
      else{
        navigate(`/formacoes`)
      }
    }
  }

  useEffect(() => {
    console.log("teste");
    setPageModeControl(
      action==='subscription'?1:
      action==='certificate'?2:
      action==='lastyear'?3:
      action==='current'?4:0
    );
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    console.log("coursesListSubscription",coursesListSubscription);
    // eslint-disable-next-line
  }, [coursesListSubscription]);

  useEffect(() => {
    setPageModeControl(
      action==='subscription'?1:
      action==='certificate'?2:
      action==='lastyear'?3:
      action==='current'?4:0
    );
    // eslint-disable-next-line
  }, [action]);

  useEffect(() => {
    loadCourses();
    // eslint-disable-next-line
  }, [pageModeControl]);

  useEffect(() => {
    console.log("controlList",controlList);
    // eslint-disable-next-line
  }, [controlList]);

  return (
    <Container>
      {(getCoursesInfo.loading ||
        getCertificateInfo.loading ||
        UnsubscribeInfo.loading) && (
        <FullScreenLoading />
      )}
      <Menu />
      <Banner
        icon={images.iconFormacoes}
        url="/formacoes/add"
        editorId={editorId}
      >
        { (controlList.type.name===null && controlList.segment.name===null)?"FORMAÇÕES":
          (controlList.segment.name===null)?controlList.type.name:controlList.segment.name
        }
      </Banner>
      <ContentBox>
        <Voltar visible={pageModeControl!==0} onClick={()=>{back();}}>Voltar</Voltar>
        <ContainerOptions visible={pageModeControl===0}>
          <div onClick={()=>{navigate(`/formacoes/current`)}}>Formações {getYear(new Date())}</div>
          <div onClick={()=>{navigate(`/formacoes/lastyear`)}}>Formações {getYear(new Date())-1}</div>
          {user && <div onClick={()=>{navigate(`/formacoes/subscription`)}}>Minhas Formações</div>}
          {certificateList.filter((certificate)=>{return !certificate.canceled;}).length>0 && <div onClick={()=>{navigate(`/formacoes/certificate`)}}>Meus Certificados</div>}
        </ContainerOptions>

        {
          (pageModeControl===3||pageModeControl===4) && coursesList.length<1 && <Alert visible={true}>
            <ImgAtencao src={icons.icon_atencao} />
            {user==null ? (<>
              Não há cursos a serem exibidos, por favor, verifique se você está logado. 
              <div onClick={()=>{navigate(`/login/redirect/*formacoes*`)}}>Clique aqui para logar</div> </>)
              :
              (<> Não há cursos a serem exibidos, por favor, acesse "Meu espaço" e verifique se seus dados de perfil
              estão corretos.</>)
            }
          </Alert> 
        }

        <ContainerOptions visible={(pageModeControl===3||pageModeControl===4)&&controlList.type.list.length===0&&coursesList.length>0}>
          {coursesList.map((courseType)=>{
            if(courseType.segments.length>0){
              return (
                <div onClick={()=>{setControlList(
                  {
                    type:{
                      name:courseType.courseTypeName,
                      list:courseType.segments
                    },
                    segment:{
                      name:null,
                      list:courseType.segments.length===1?courseType.segments[0].courses:[]
                    }})}
                  }>
                  {courseType.courseTypeName}
                </div>
              )
            }
          })}
        </ContainerOptions>

        <ContainerOptions visible={(pageModeControl===3||pageModeControl===4)&&controlList.type.list.length>0&&controlList.segment.list.length===0}>
          {
            controlList.type.list.map((segment)=>(
              <div onClick={()=>{setControlList({type:controlList.type,segment:{name:segment.segmentName,list:segment.courses}})}}>
                  {segment.segmentName===null?"Outros":segment.segmentName}
              </div>
            ))
          }
        </ContainerOptions>

        <ListContent visible={(pageModeControl===3||pageModeControl===4)&&controlList.type.list.length>0&&controlList.segment.list.length>0}>
          {
            controlList.segment.list.map((course)=>(
              <Item>
                {renderCourse(course)}
              </Item>
            ))
          }
        </ListContent>

        <ListContent visible={pageModeControl===1}>
          {
            coursesListSubscription.map((course)=>(
              <Item>
                {renderCourse(course)}
              </Item>
            ))                  
          }
        </ListContent>

        <ListContent visible={pageModeControl===2}>
          {certificateList.filter((certificate)=>{return !certificate.canceled;}).length>0?
            certificateList.filter((certificate)=>{return !certificate.canceled;}).map((certificate)=>
            <Certificate
              key={certificate.idCertificate}
              roundborder={false}
              reduct={0}
              visible={pageModeControl===2}
            >
              {certificate.courseTitle} - {format(new Date(certificate.createdAt), " dd/MM/yyyy", {locale: ptBR,})}
              <ReadMoreButton onClick={()=>{navigate(`/coursecertificate/${certificate.idCertificate}`);}} text="Visualizar Certificado" />
            </Certificate>)
          :"Não há certificados a serem exibidos"}
        </ListContent>

        <Modal  open={ModalOpenAlertUnsubscribe} close={handleModalAlertUnsubscribe} buttonClose = {false} width={50} height={15}>
          <Message>
            <div>{unsubscriptionStatusMessage}</div>
            <ReadMoreButton onClick={handleAlertUnsubscribeOk} text="Ok" />
          </Message>
        </Modal>

      </ContentBox>
      <Footer />
    </Container>
  );
};

export default Courses;